import { atom } from 'jotai';

const showLegalModalAtom = atom<boolean>(false);
const legalModalDataTestIdAtom = atom<string>('');
const legalModalTitleAtom = atom<string>('');
const legalModalSrcAtom = atom<string>('');

export const LegalModalState = {
  showLegalModalAtom,
  legalModalDataTestIdAtom,
  legalModalTitleAtom,
  legalModalSrcAtom,
};
